import React from "react";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";

import "./ContactUsEthicsConcern.css";

const ContactUsEthicsConcern = () => {
    return (
        <WidgetContainer>
            <div className="cu-ethics-concern">
                <div className="cu-ethics-concern__head">
                    <h1>Report Ethics Concerns</h1>
                    <p>
                        We have the following resources available for you to
                        raise questions and concerns around PhonePe Ethics.
                        Concerns are always confidential and you may choose to
                        report them anonymously.
                    </p>
                </div>
                <div className="cu-ethics-concern__content">
                    <div className="cu-ethics-concern__content__item">
                        <h2>Report your Concern Online</h2>
                        <p>
                            Click
                            <a
                                href="https://www.phonepeethics.com/content/phonepe-ethics/en_us/contact-us.html"
                                className="purple-text underlined-link"
                                target="_blank"
                            >
                                here
                            </a>
                            to report a concern regarding the Code of Conduct.
                        </p>
                    </div>
                    <div className="cu-ethics-concern__content__item">
                        <h2>Call Us</h2>
                        <p>
                            Call the Ethics helpline at
                            <a
                                href="tel: +1800-102-1482"
                                className="purple-text"
                            >
                                1800-102-1482
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default ContactUsEthicsConcern;
